import React, { Component } from 'react'
import PageProduit from './PageProduit'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { getValueFromUrlValue } from '../../../../../utils'
import ErrorPage from '../../../ErrorPage'

const queryProductsOfCategory = gql`
  query GetProductsOfCategory($category: String!) {
    getProductsOfCategory(category: $category) {
      regionsWithProducts {
        region {
          id
          name
        }
        products {
          id
          name
          available
          producerProfile {
            id
            companyName
          }
          photosProduct {
            cloudPath
          }
        }
      }
      error
    }
  }
`

const querySearchProducts = gql`
  query FindProducts($query: String!) {
    findProducts(query: $query) {
      id
      name
      description
      producerProfile {
        id
        companyName
      }
      photosProduct {
        cloudPath
      }
    }
  }
`

const AvailabledSearchMetadata = {
  panier: {
    title:
      'Panier fruits et légumes en vente directe producteur - Acheter à la Source',
    description:
      'Panier fruits et légumes en vente directe producteur sur Acheter à la Source. Découvrez tous les producteurs proches de chez vous et profitez de leurs produits de qualité !'
  }
}

class PageProduitContainer extends Component {
  render() {
    const {
      match: { params }
    } = this.props
    const category = getValueFromUrlValue(params.category)

    return params.category in AvailabledSearchMetadata ? (
      <Query query={querySearchProducts} variables={{ query: params.category }}>
        {({ loading, data }) => (
          <PageProduit
            title={AvailabledSearchMetadata[params.category].title}
            description={AvailabledSearchMetadata[params.category].description}
            data={
              !loading && data
                ? {
                    regionsWithProducts: [
                      {
                        region: {
                          id: 0,
                          name: 'France'
                        },
                        products: data.findProducts
                      }
                    ]
                  }
                : null
            }
            loading={loading}
            category={params.category}
          />
        )}
      </Query>
    ) : (
      <Query query={queryProductsOfCategory} variables={{ category }}>
        {({ loading, data }) =>
          !loading && data && (data.getProductsOfCategory || {}).error ? (
            <ErrorPage />
          ) : (
            <PageProduit
              data={!loading && data ? data.getProductsOfCategory : null}
              loading={loading}
              category={category}
            />
          )
        }
      </Query>
    )
  }
}

export default PageProduitContainer
